const Strings = {
  BOOK_LAUNDRY: {
    SE: 'Boka tvättid',
    EN: 'Book laundrytime'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/laundries/LaundryBooking/strings.js